
import Component from 'vue-class-component';
import { Watch } from 'vue-property-decorator';
import Vue from 'vue';
import stores from '@/store/core/RootStore';
import { Credentials } from '@/api/services/userService/types';

@Component({
  name: 'AuthLoginIndex',
})
export default class AuthLoginIndex extends Vue {
  user = stores.user;

  loginData: Credentials = {
    login: '',
    password: '',
  };

  get isFormInputValid(): boolean {
    return Object.values(this.loginData).every((item) => item);
  }

  async login() {
    try {
      await this.user.LOGIN(this.loginData);
      this.$router.push({ path: '/' });
    } catch (e) {
      console.warn(e);
    }
  }

  get isNeedLoader() {
    if (this.$route.query.key && this.$route.query.key === 'hxygKbvT') {
      return true;
    }

    return false;
  }

  @Watch('loginData', { deep: true })
  fn() {
    this.user.setError(null);
  }
}
